<template>
    <div>
        <div v-for="(icard, index) in icard_data" :key="index">
        <div class="" style="width: 31rem;">
            <v-row style="background-color: #8b3a37; color: white; border-bottom: 1px solid black; height: 110px;">
                <v-col cols="12" sm="2" md="2" class="pl-6" align="right">
                    <img
                    :src="common_data.logo"
                    style="width: 70px; height: 70px;"
                    alt="logo"
                  />
                </v-col>
                <v-col cols="12" sm="9" md="9" align="center">
                    <h6>TMV'S SCHOOL</h6>
                    <h3 style="margin-top: -3px;margin-bottom: -3px;">TILAK MAHARASHTRA VIDYALAYA</h3>
                    <div style="font-size: 10px; margin-bottom: -3px;">(PRE-PRIMARY, PRIMARY AND SECONDARY)</div> 
                    <b style="font-size: 10px; ">{{ common_data.school_address }}. &nbsp;&nbsp;&nbsp;&nbsp; Tel No. {{ common_data.school_contact }}</b>
                    <div style="background-color: white; color: #8b3a37; width: 70px; border-radius: 10px; font-size: 10px;">CBSE Pattern</div>
                </v-col>
            </v-row>
            <v-row>
                <!-- <v-img  style="opacity: 0.5;margin-left: 100px;width: 50px;height: 50px; " height="277px" :src="common_data.watermark"> -->
                    <v-col cols="12" sm="4" md="4" class="pb-0 pt-2">
                        <div
                            v-if="icard.icard_temp.emp_photo"
                            class="row"
                            style="
                            justify-content: center;
                            margin-top: 5px;
                            margin-bottom: 5px;
                            margin-left: 2px;
                            "
                        >
                            <img
                            v-if="icard.icard_temp.emp_photo"
                            style="border: 3px solid black"
                            :src="awspath + icard.icard_temp.emp_photo.field_value"
                            width="130px"
                            height="130px"
                            alt="Employee photo"
                            />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="7" md="7" align="left" class="pl-2 pb-0" style="font-size: 14px;">
                        <b>Name :  </b>{{ icard.icard_temp.emp_fullname.field_value }}<br>
                        <b>Address : </b>{{ icard.icard_temp.emp_address.field_value }} <br>
                        <b>Phone : </b>{{ icard.icard_temp.emp_mobile_no.field_value }} <br>
                        <b>Deisgnation : </b>{{ icard.icard_temp.emp_designation.field_value }} <br>
                        <b>Date of Birth : </b>{{ icard.icard_temp.emp_date_of_birth.field_value }} <br> 
                        <b>Blood Group : </b>{{ icard.icard_temp.emp_blood_group.field_value }} <br>                    
                    </v-col>                   
                <!-- </v-img> -->
            </v-row>
            <v-row dense justify="end" style="margin-top: -10px;"> 
                <v-col cols="12" sm="4" class="pt-0" align="center">
                      <img
                        :src="common_data.sign"
                        alt="signature"
                        style="width: 30px; height: 30px"
                      /> <br>
                      <div style="font-size: 10px; margin-top: -5px;"><b>Principal Sign</b></div>
                    </v-col>
            </v-row>
            
        </div>
      </div>
    </div>
  </template>
  <script>
  import axios from "axios";
  import VueBarcode from "vue-barcode";
  import QrcodeVue from "qrcode.vue";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  
  export default {
    components: {
      barcode: VueBarcode,
      QrcodeVue,
    },
    data: () => ({
      stud_data: null,
      comp_load: false,
      icard_data: [],
      tenant: null,
      org_id: null,
    }),
    
    mounted() {
      this.inst_data = localStorage.getItem("inst_data");
      this.icard_data = JSON.parse(localStorage.getItem("icard_data"));
      this.common_data = JSON.parse(localStorage.getItem("common_data"));
      this.awspath = localStorage.getItem("awspath");
      this.tenant = localStorage.getItem("EPS-tenant");
      this.org_id = localStorage.getItem("EPS-org-id");
    },

    methods: {
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
  };
  </script>
  <style scoped>  
  @media print {  
    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
      display: none !important;
    }
  
    @page {
      /* margin: 0mm; */
      margin: -1.2645833mm;
      size: 85mm 55mm;
      /* size: 53mm 85mm; */
    }
  }
  </style>